import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { Notification, NotificationType } from './notification';
import { NotificationService } from './notification.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit, OnDestroy {

  notifications: Notification[] = [];
  private _subscription: Subscription;

  constructor(
    public notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this._subscription = this.notificationService.getObservable()
      .subscribe(notification => {
        this._addNotification(notification)
        console.log('notify', this)
      });
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }

  private _addNotification(notification: Notification) {
    this.notifications.push(notification);

    if (notification.timeout !== 0) {
      setTimeout(() => this.close(notification), notification.timeout);
    }
  }

  close(notification: Notification) {
    this.notifications = this.notifications.filter(notif => notif.id !== notification.id);
  }

  className(notification: Notification): string {
    let style: string = '';

    switch (notification.type) {

      case NotificationType.info:
        style = 'bg-info text-light';
        break;

      case NotificationType.success:
        style = 'bg-success text-light';
        break;

      case NotificationType.warning:
        style = 'bg-warning text-light';
        break;

      case NotificationType.error:
        style = 'bg-danger text-light';
        break;

    }

    return style;
  }

}
